import { scrollTo } from 'scroll-js';

export default class Hash {
    private selector: HTMLElement;
    private header: HTMLElement;

    constructor(selector: string) {
        this.selector = document.querySelector(selector);
        this.header = document.querySelector('[data-header]');

        if (this.selector && this.header) {
            this.init();
        }
    }

    private init(): void {
        const { hash } = window.location;

        if (hash) {
            const scrollToElement: HTMLElement = document.querySelector(`[data-hash="${hash}"]`);

            if (scrollToElement) {
                scrollTo(document.body, {
                    top: scrollToElement.offsetTop - this.header.offsetHeight,
                    easing: 'ease-in-out',
                    duration: 1000,
                });
            }
        }
    }
}
